import { Directive } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'td-wb-side-sheet-selector-toggle'
})
export class SideSheetSelectorToggleDirective {
}
